module.exports = __webpack_public_path__ + "img/fruit-plums-350x184.fe75b3f3.jpg";